import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'cs',
  months: [
    'ledna',
    'února',
    'března',
    'dubna',
    'května',
    'června',
    'července',
    'srpna',
    'září',
    'října',
    'listopadu',
    'prosince',
  ],
  monthsShort: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
  weekdays: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'],
  weekdaysMin: ['N', 'P', 'Ú', 'S', 'Č', 'P', 'S'],
  weekdaysShort: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'D.M.YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY HH:mm',
    'LLL-Y': 'D. MMMM HH:mm',
    LLLL: 'dddd D. MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D. MMMM HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D. M.',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    'll-D': 'MMMM YYYY',
    lll: 'D. MMM YYYY HH:mm',
    'lll-Y': 'D. MMM HH:mm',
    llll: 'ddd D. MMM YYYY HH:mm',
    'llll-Y': 'ddd D. MMM HH:mm',
    'll-Y+w': 'ddd D. MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'dop.', pm: 'odp.', AM: 'dop.', PM: 'odp.' },
  past: {
    y: { one: 'před %s r.', few: 'před %s r.', many: 'před %s r.', other: 'před %s l.' },
    M: { one: 'před %s měs.', few: 'před %s měs.', many: 'před %s měs.', other: 'před %s měs.' },
    w: { one: 'před %s týd.', few: 'před %s týd.', many: 'před %s týd.', other: 'před %s týd.' },
    d: { one: 'před %s d', few: 'před %s d', many: 'před %s d', other: 'před %s d' },
    h: { one: 'před %s h', few: 'před %s h', many: 'před %s h', other: 'před %s h' },
    m: { one: 'před %s min', few: 'před %s min', many: 'před %s min', other: 'před %s min' },
    s: { one: 'před %s s', few: 'před %s s', many: 'před %s s', other: 'před %s s' },
  },
  future: {
    y: { one: 'za %s r.', few: 'za %s r.', many: 'za %s r.', other: 'za %s l.' },
    M: { one: 'za %s měs.', few: 'za %s měs.', many: 'za %s měs.', other: 'za %s měs.' },
    w: { one: 'za %s týd.', few: 'za %s týd.', many: 'za %s týd.', other: 'za %s týd.' },
    d: { one: 'za %s d', few: 'za %s d', many: 'za %s d', other: 'za %s d' },
    h: { one: 'za %s h', few: 'za %s h', many: 'za %s h', other: 'za %s h' },
    m: { one: 'za %s min', few: 'za %s min', many: 'za %s min', other: 'za %s min' },
    s: { one: 'za %s s', few: 'za %s s', many: 'za %s s', other: 'za %s s' },
  },
  pastLong: {
    y: { one: 'před %s rokem', few: 'před %s lety', many: 'před %s roku', other: 'před %s lety' },
    M: { one: 'před %s měsícem', few: 'před %s měsíci', many: 'před %s měsíce', other: 'před %s měsíci' },
    w: { one: 'před %s týdnem', few: 'před %s týdny', many: 'před %s týdne', other: 'před %s týdny' },
    d: { one: 'před %s dnem', few: 'před %s dny', many: 'před %s dne', other: 'před %s dny' },
    h: { one: 'před %s hodinou', few: 'před %s hodinami', many: 'před %s hodiny', other: 'před %s hodinami' },
    m: { one: 'před %s minutou', few: 'před %s minutami', many: 'před %s minuty', other: 'před %s minutami' },
    s: { one: 'před %s sekundou', few: 'před %s sekundami', many: 'před %s sekundy', other: 'před %s sekundami' },
  },
  futureLong: {
    y: { one: 'za %s rok', few: 'za %s roky', many: 'za %s roku', other: 'za %s let' },
    M: { one: 'za %s měsíc', few: 'za %s měsíce', many: 'za %s měsíce', other: 'za %s měsíců' },
    w: { one: 'za %s týden', few: 'za %s týdny', many: 'za %s týdne', other: 'za %s týdnů' },
    d: { one: 'za %s dnem', few: 'za %s dny', many: 'za %s dne', other: 'za %s dny' },
    h: { one: 'za %s hodinu', few: 'za %s hodiny', many: 'za %s hodiny', other: 'za %s hodin' },
    m: { one: 'za %s minutu', few: 'za %s minuty', many: 'za %s minuty', other: 'za %s minut' },
    s: { one: 'za %s sekundu', few: 'za %s sekundy', many: 'za %s sekundy', other: 'za %s sekund' },
  },
  abbr: {
    y: { one: '%s r.', few: '%s r.', many: '%s r.', other: '%s l.' },
    M: { one: '%s měs.', few: '%s měs.', many: '%s měs.', other: '%s měs.' },
    w: { one: '%s týd.', few: '%s týd.', many: '%s týd.', other: '%s týd.' },
    d: { one: '%s d', few: '%s d', many: '%s d', other: '%s d' },
    h: { one: '%s h', few: '%s h', many: '%s h', other: '%s h' },
    m: { one: '%s min', few: '%s min', many: '%s min', other: '%s min' },
    s: { one: '%s s', few: '%s s', many: '%s s', other: '%s s' },
  },
  full: {
    y: { one: '%s rok', few: '%s roky', many: '%s roku', other: '%s let' },
    M: { one: '%s měsíc', few: '%s měsíce', many: '%s měsíce', other: '%s měsíců' },
    w: { one: '%s týden', few: '%s týdny', many: '%s týdne', other: '%s týdnů' },
    d: { one: '%s den', few: '%s dny', many: '%s dne', other: '%s dnů' },
    h: { one: '%s hodina', few: '%s hodiny', many: '%s hodiny', other: '%s hodin' },
    m: { one: '%s minuta', few: '%s minuty', many: '%s minuty', other: '%s minut' },
    s: { one: '%s sekunda', few: '%s sekundy', many: '%s sekundy', other: '%s sekund' },
  },
  justNow: 'Právě teď',
  yesterday: 'Včera',
  today: 'Dnes',
  tomorrow: 'Zítra',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D. MMMM YYYY', end: 'D. MMMM YYYY' },
    'yl-1': { start: 'D. MMMM', end: 'D. MMMM YYYY' },
    ml: { start: 'D. MMMM', end: 'D. MMMM' },
    'ml-1': { start: 'D.', end: 'D. MMMM YYYY' },
    dl: { start: 'D.', end: 'D. MMMM' },
    y: { start: 'D. MMM YYYY', end: 'D. MMM YYYY' },
    'y-1': { start: 'D. MMM', end: 'D. MMM YYYY' },
    m: { start: 'D. MMM', end: 'D. MMM' },
    'm-1': { start: 'D.', end: 'D. MMM YYYY' },
    d: { start: 'D.', end: 'D. MMM' },
    Y: { start: 'ddd D. MMM YYYY', end: 'ddd D. MMM YYYY' },
    'Y-1': { start: 'ddd D. MMM', end: 'ddd D. MMM YYYY' },
    M: { start: 'ddd D. MMM', end: 'ddd D. MMM' },
    D: { start: 'ddd D. MMM', end: 'ddd D. MMM' },
    yt: { start: 'D. MMM YYYY HH:mm', end: 'D. MMM YYYY HH:mm' },
    mt: { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm' },
    dt: { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D. MMM YYYY HH:mm', end: 'D. MMM YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'cs';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'dop.' : 'dop.';
    } else {
      return isLowerCase ? 'odp.' : 'odp.';
    }
  },
};
